module.exports = __webpack_public_path__ + "img/Group 5.10aa77c1.svg";